import * as types from '../../action-types';
import { generateReferralCode as initialState } from "../../initialState";

const generateReferralCode = (state=initialState, action) => {
  switch (action.type) {
    case types.GENERATE_REFERRAL_CODE_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GENERATE_REFERRAL_CODE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GENERATE_REFERRAL_CODE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GENERATE_REFERRAL_CODE_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default generateReferralCode;
